import React from 'react';
import EvaluationEpst from './ViewEpst';


const index = (props) => (
    <EvaluationEpst />
);

export default index;